import { defineStore } from 'pinia'
import { store } from '../index'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import ar from 'element-plus/es/locale/lang/ar'
import pt from 'element-plus/es/locale/lang/pt'
import id from 'element-plus/es/locale/lang/id'
import { useStorage } from '@/hooks/web/useStorage'
import { LocaleDropdownType } from '@/components/LocaleDropdown'

const { getStorage, setStorage } = useStorage('localStorage')

const elLocaleMap: Record<string, any> = {
  'zh-CN': zhCn,
  en: en,
  ar: ar,
  pt: pt,
  id: id
}

interface LocaleState {
  currentLocale: LocaleDropdownType
  localeMap: LocaleDropdownType[]
}

export const useLocaleStore = defineStore('locales', {
  state: (): LocaleState => {
    return {
      currentLocale: {
        lang: getStorage('lang') || 'en',
        elLocale: elLocaleMap[getStorage('lang') || 'en'],
        serviceId: getStorage('serviceId') || 'en'
      },
      // 多语言
      localeMap: [
        {
          lang: 'en',
          name: 'English'
        },
        {
          lang: 'zh-CN',
          name: '简体中文'
        },
        {
          lang: 'ar',
          name: 'العربية'
        },
        {
          lang: 'pt',
          name: 'Português'
        },
        {
          lang: 'id',
          name: 'Bahasa Indonesia'
        }
      ]
    }
  },
  getters: {
    getCurrentLocale(): LocaleDropdownType {
      return this.currentLocale
    },
    getLocaleMap(): LocaleDropdownType[] {
      return this.localeMap
    }
  },
  actions: {
    setCurrentLocale(localeMap: LocaleDropdownType) {
      console.log('setCurrentLocale', localeMap)
      this.currentLocale.lang = localeMap?.lang
      this.currentLocale.elLocale = elLocaleMap[localeMap?.lang] || en
      this.currentLocale.serviceId = localeMap?.serviceId
      setStorage('lang', localeMap?.lang)
      setStorage('serviceId', localeMap?.serviceId)
    }
  }
})

export const useLocaleStoreWithOut = () => {
  return useLocaleStore(store)
}
